/*
 * @Author: 丨小小风离丨
 * @Date: 2024-04-22 16:09:08
 * @LastEditTime: 2025-01-22 14:32:33
 * @LastEditors: 丨小小风离丨
 * @FilePath: \web-school-enroll\src\page\teachins\list\teachinsList.tsx
 * @Description: 
 */
import StatusTips from "@/components/statusTips";
import { LgButton, LgSealMark } from "lancoo-web-ui";
import './teachinsList.scss';
import { nameTips } from "../common/publicFunc";
import { setIsPopoverVisible } from "../../../store/reducers/userInfo";
import { useDispatch } from "react-redux";

export default function TeachinList(props: any) {
    const {
        list = [],
        optionFun
    } = props;

    const dispatch = useDispatch();

    return (
        <div className="teachins_detail_header">
            {list?.length > 0 && list?.map(ele => {
                return <div key={ele.id}
                    className="con_list_wrapper"
                    onClick={() => {
                        optionFun.checkPlan(ele)
                    }}
                >
                    <div className="con_list">
                        <div className="list">
                            <div
                                className="coverimg"
                                style={{
                                    backgroundImage: `url(${ele?.coverImgs?.[0]?.preUrl || ''})`,
                                    cursor: 'pointer'
                                }}
                            />
                            <div className="moremsg">
                                <div className="title">
                                    {ele?.tiName || ''}
                                    <StatusTips
                                        style={{ color: nameTips(ele?.state || 0).color }}
                                        text={nameTips(ele?.state || 0).text}
                                    />
                                    {ele?.top === 1 && <div className="teachinsDetailTop"></div>}
                                </div>
                                <div style={{ marginBottom: 5 }}>
                                    所属招生计划:
                                    <span className="content">
                                        {/* 2023-2024学年 */}
                                        {ele?.planName || "--"}
                                    </span>
                                </div>
                                <div style={{ marginBottom: 5 }}>
                                    负责教师:
                                    <span className="content">
                                        <span>{ele?.tiTeacher?.split("~")?.[1] || '--'}</span>
                                    </span>
                                    联系电话:
                                    <span className="content">
                                        {ele?.tiMobile || "--"}
                                    </span>
                                </div>
                                <div>
                                    地点:
                                    <span className="content">
                                        {(ele?.classroomStatus === null || ele?.classroomStatus === undefined) ? (ele?.tiLocation ? ele?.tiLocationType == 1 ? '校内/' : '校外/' : '') : ''}
                                        {(ele.tiLocationType == 1 && !ele.locationId) ? ele.tiLocation.split('~')[1] : ele.tiLocation}
                                    </span>
                                    宣讲会日期:
                                    <span className="content">
                                        {
                                            ele?.tiStartTime?.slice?.(0, ele?.tiStartTime?.length - 3) + '~' +
                                            ele?.tiEndTime?.slice?.(0, ele?.tiEndTime?.length - 3)
                                        }
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div className="btn">
                            {ele?.registered &&
                                <LgSealMark status="passed" style={{ width: 98, opacity: 0.5 }} >
                                    已登记
                                </LgSealMark>
                            }
                            <div style={{
                                marginRight: 34,
                                width: '1px',
                                height: '94px',
                                // backgroundImage: "linear-gradient(to right, white, white 50%, #e5e5e5 50%, #e5e5e5)",
                                background: "linear-gradient(to bottom, white 0%, #e5e5e5 50%, white 100%)",
                            }}></div>
                            <div style={{ display: 'flex', flexFlow: 'column' }}>
                                <span
                                    title={ele.state > 0 ? ele.state > 1 ? "宣讲会已结束" : "宣讲会进行中" : ""}
                                    onClick={(e) => {
                                        e.stopPropagation()
                                        if (((ele.state > 1 && !ele?.registered) || (ele.classroomStatus && ele.classroomStatus > 2))) {
                                            return
                                        }
                                        dispatch(setIsPopoverVisible(false));
                                        optionFun.enroll(ele)
                                    }}
                                >
                                    <LgButton
                                        backgroundType={ele?.registered ? 'translucent' : 'opacification'}
                                        border={ele?.registered}
                                        type='info'
                                        style={{ justifyContent: 'center', width: 118 }}
                                        disable={((ele.state > 1 && !ele?.registered) || (ele.classroomStatus && ele.classroomStatus > 2))}
                                    >
                                        {ele?.registered ? '查看登记信息' : '信息登记'}
                                    </LgButton>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div style={{ width: '100%', height: 1, backgroundColor: '#000000', opacity: 0.12 }}></div>
                </div>
            })}
        </div>
    );
};
